import React from "react";
import { Link } from "react-router-dom";
import { Facebook, MapPin, Phone, Globe } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-16 sm:mt-24 bg-[#1C2826] text-[#D9DFDB]">
      {/* Top grid: brand + shop + offices */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
        <div className="sm:col-span-2 lg:col-span-1">
          <div className="flex items-center gap-2 mb-3">
            <img src="/assets/arbe-logo.png" alt="Arbe Minimart" className="h-12 w-12 sm:h-14 sm:w-14 object-contain bg-white rounded-full p-1" />
            <span className="font-heading font-extrabold text-base sm:text-lg text-[#C62828]">ARBE MINIMART</span>
          </div>
          <p className="text-sm leading-relaxed">Your local store for fresh and quality meats, groceries and pantry essentials — now delivered.</p>
        </div>

        <div>
          <h4 className="font-heading font-semibold text-white mb-3">Shop</h4>
          <ul className="text-sm space-y-2">
            <li>Groceries</li>
            <li>Meats</li>
            <li>Condiments</li>
            <li>Frozen Products</li>
            <li>Sunjin Feeds</li>
          </ul>
          <h4 className="font-heading font-semibold text-white mb-3 mt-6">Pay with</h4>
          <ul className="text-sm space-y-2">
            <li>GCash</li>
            <li>Maya</li>
            <li>Bank Transfer</li>
            <li>PayPal</li>
            <li>Cash on Delivery</li>
          </ul>
        </div>

        <div data-testid="footer-main-office">
          <h4 className="font-heading font-semibold text-white mb-3 flex items-center gap-2">
            <MapPin className="h-4 w-4 text-[#C62828]" /> Main Office
          </h4>
          <address className="text-sm not-italic leading-relaxed text-[#D9DFDB]">
            Arbe Minimart<br />
            Militante Street D&apos;ban<br />
            Don Bernardo Neri Poblacion<br />
            Calamba, Misamis Occidental<br />
            7210
          </address>
        </div>

        <div data-testid="footer-branch">
          <h4 className="font-heading font-semibold text-white mb-3 flex items-center gap-2">
            <MapPin className="h-4 w-4 text-[#C62828]" /> Branch 1
          </h4>
          <address className="text-sm not-italic leading-relaxed text-[#D9DFDB]">
            Arbe Minimart<br />
            Felix Taghap Street<br />
            Poblacion 2<br />
            Oroquieta City<br />
            7207
          </address>
        </div>
      </div>

      {/* Bottom band: Contact + Online + Website */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 sm:py-6 flex flex-col sm:flex-row sm:flex-wrap items-start sm:items-center justify-between gap-4 sm:gap-x-8 sm:gap-y-3">
          <div className="flex items-center gap-2 text-sm" data-testid="footer-contact">
            <Phone className="h-4 w-4 text-[#C62828]" />
            <span className="font-semibold text-white">Contact:</span>
            <a href="tel:079202971717" className="hover:text-white transition-colors" data-testid="footer-phone-1">079202971717</a>
            <span className="text-[#8A9591]">/</span>
            <a href="tel:09202799298" className="hover:text-white transition-colors" data-testid="footer-phone-2">09202799298</a>
          </div>
          <div className="flex items-center gap-2 text-sm" data-testid="footer-online">
            <Globe className="h-4 w-4 text-[#C62828]" />
            <span className="font-semibold text-white">Online:</span>
            <a href="https://arbeminimart.com" className="hover:text-white transition-colors">Arbeminimart.com</a>
          </div>
          <a
            href="https://www.facebook.com/ArbeMinimart"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm hover:text-white transition-colors"
            data-testid="footer-facebook"
          >
            <Facebook className="h-4 w-4 text-[#C62828]" />
            <span className="font-semibold text-white">Facebook:</span>
            <span>Arbe Minimart</span>
          </a>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-3 text-xs text-[#8A9591]">
          <span className="font-semibold text-white/80">Service area:</span> We deliver fresh meats, groceries and frozen products across <span className="text-white">Oroquieta City, Misamis Occidental</span>. Calamba delivery coming soon.
        </div>
      </div>

      <div className="border-t border-white/10 py-5 px-4 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-[#8A9591]">
        <span>© {new Date().getFullYear()} Arbe Minimart. All rights reserved.</span>
        <Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
        <Link to="/terms" className="hover:text-white transition-colors" data-testid="footer-terms">Terms of Service</Link>
      </div>
    </footer>
  );
}
